<div class="content">
  <div class="container-fluid">
    <button type="button" class="btn btn-primary" (click)="deleteData()">Borrar datos mock</button>
    <button type="button" class="btn btn-primary ml-2" (click)="createData()">Crear datos mock</button>
  </div>
</div>
